import { render } from "./BlockListEdit.vue?vue&type=template&id=2cf55e58&scoped=true"
import script from "./BlockListEdit.vue?vue&type=script&lang=js"
export * from "./BlockListEdit.vue?vue&type=script&lang=js"

import "./BlockListEdit.vue?vue&type=style&index=0&id=2cf55e58&scoped=true&lang=less"
import "./BlockListEdit.vue?vue&type=style&index=1&id=2cf55e58&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf55e58"]])

export default __exports__